(function () {
  var header = document.getElementById("ck-header");
  var menuBtn = document.querySelector("[data-ck-menu]");
  var mobileNav = document.getElementById("ck-mobile-nav");
  var sticky = document.getElementById("ck-sticky");
  var hero = document.getElementById("hero");

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", function () {
      var open = mobileNav.hasAttribute("hidden") === false;
      if (open) {
        mobileNav.setAttribute("hidden", "");
        mobileNav.style.display = "none";
        menuBtn.setAttribute("aria-expanded", "false");
      } else {
        mobileNav.removeAttribute("hidden");
        mobileNav.style.display = "block";
        menuBtn.setAttribute("aria-expanded", "true");
        if (header) header.classList.add("is-solid");
      }
      syncSticky();
    });
    mobileNav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mobileNav.setAttribute("hidden", "");
        mobileNav.style.display = "none";
        menuBtn.setAttribute("aria-expanded", "false");
      });
    });
  }

  function syncSticky() {
    var menuOpen = mobileNav && mobileNav.hasAttribute("hidden") === false;
    if (header) {
      var pastHero = hero ? window.scrollY > Math.max(hero.offsetHeight - 72, 120) : window.scrollY > 80;
      header.classList.toggle("is-solid", pastHero || menuOpen);
    }
    if (!sticky || !hero) return;
    var mobile = window.matchMedia("(max-width: 767px)").matches;
    var cta = document.querySelector(".ck-hero__cta .ck-btn");
    var ctaLeft = cta ? cta.getBoundingClientRect().bottom < 12 : window.scrollY > 280;
    var offer = document.getElementById("offer");
    var offerBox = offer ? offer.getBoundingClientRect() : null;
    var offerInView = offerBox && offerBox.top < window.innerHeight - 72 && offerBox.bottom > 96;
    if (mobile && ctaLeft && !offerInView) {
      sticky.classList.add("is-on");
      document.body.classList.add("ck-sticky-pad");
    } else {
      sticky.classList.remove("is-on");
      document.body.classList.remove("ck-sticky-pad");
    }
  }

  var heroCta = document.querySelector(".ck-hero__cta .ck-btn");
  if (heroCta && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function () { syncSticky(); }, { threshold: [0, 0.01, 1] });
    io.observe(heroCta);
    var offerEl = document.getElementById("offer");
    if (offerEl) io.observe(offerEl);
  }

  window.addEventListener("scroll", syncSticky, { passive: true });
  window.addEventListener("resize", syncSticky);
  syncSticky();
})();
